module.exports = __webpack_public_path__ + "static/media/ic-3.91fba1ab.svg";